// src/models/userModel.ts
import {
	queryKnowledgeForPage,
	knowledgeInfoById,
	uploadKnowledgeBySave,
	folderDetails,
	create_index,
	delete_points,
	delKnowledgeOrDisable,
	recoverFolder
} from '@/services/AssistantInfo';
import {
	replaceFolder
} from '@/services/global';
import { useRequest, useModel } from '@umijs/max';
import { SetStateAction, useEffect, useMemo, useState } from 'react';
import useTableQuery from '@/hooks/useTableQuery';
import { fileFormat } from "@/utils";
import { message } from 'antd';


const KnowledgeType: any = {
	1: '营销案例',
	2: '集团传播政策',
	3: '品牌信息',
	9: '产品信息',
	12: 'SEO关键字表',
}

const initInfo = {
	"folderId": "",
	"fileName": "",
	"pageNum": 1,
	"pageSize": 9999,
	"modeName": ''
}

export default function () {
	const { pageId } = useModel('AssistantInfo.assistantInfo')
	const [folderId, setfolderId] = useState<number>(); //知识库选中id
	const [selectKnowId, setselectKnowId] = useState<any>(); //选中知识id
	const [folderInfo, setfolderInfo] = useState<any>(); //知识库选中信息
	const [konwSelectInfo, setKonwSelectInfo] = useState<any>(); //知识库选中信息
	const [isShowAddKnowledge, setIsShowAddKnowledge] = useState<boolean>(false); //是否显示添加知识库弹窗
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false); //是否显示编辑弹窗
	const [uploadFilesArr, setUploadFilesArr] = useState<any[]>([]); //上传文件数组
	const [uploadLoaing, setUploadLoaing] = useState<boolean>(false); //上传文件loading
	const { initialState } = useModel('@@initialState')

	const resetPage = (params: any) => {
		handlesInfo({ folderId: params[0]?.folderId || folderId })
		setfolderInfo((e: any) => { return { ...e, folderId: params[0]?.folderId } })
		handles({ id: pageId })
		setfolderId(params[0]?.folderId)
	}

	const {
		result = [],
		handles,
	} = useTableQuery(queryKnowledgeForPage, {});

	const {
		result: resultInfo = [],
		handles: handlesInfo,
		Loading,
		setResult
	} = useTableQuery(knowledgeInfoById, initInfo);

	const { run: handleReplaceFolder } = useRequest(replaceFolder, {
		manual: true,
		onSuccess: (data: any, params: any) => {
			if (data.status === 0) {
				setIsShowAddKnowledge(false)
				resetPage(params)
			}
		}
	})

	const { run: handlerecoverFolder } = useRequest(recoverFolder, {
		manual: true,
		onSuccess: (data: any, params: any) => {
			if (data.status === 0) {
				resetPage(params)
			}
		}
	})

	useEffect(() => {
		if (folderId) {
			setResult([])
			handlesInfo({ folderId: folderId }) // 获取知识库详情列表
			folderDetails(folderId).then((res) => { // 获取知识库详情
				res?.status == 0 && setKonwSelectInfo(res?.payload)
			})
		}
	}, [folderId]);

	//知识库类型列表
	const knowList = useMemo(() => {
		let mapResult = result.map((item: any) => ({ ...item, label: KnowledgeType[item.type], key: item?.id }))
		if (!folderId && result.length > 0) {
			setfolderId(mapResult[0]?.folderId)
			setselectKnowId(mapResult[0]?.id)
			setfolderInfo(mapResult[0])
		}
		return mapResult
	}, [result]);


	const firmInfo = {
		caller: initialState?.userInfo?.tenantId,
		callEnterprise: initialState?.userInfo?.enterpriseExtend?.orgId,
		create_user: initialState?.userInfo?.id,
	}

	//上传文件
	const handleOk = () => {
		setUploadLoaing(true)
		const domainObj = {
			domain1: null,
			domain2: null,
			domain3: null,
		};
		const { callCode, sceneId, modeIds, arrangement } = konwSelectInfo

		let form_json_data = JSON.parse(arrangement);
		if (form_json_data && form_json_data.ranking) {
			delete form_json_data.ranking;
		}
		let d = {
			...firmInfo,
			index_name: callCode,
			data: uploadFilesArr.map((i: any) => ({ name: i?.fileName, num_questions: '10', path: i?.fileUrl, ...domainObj })),
			params: form_json_data,
			module: modeIds,
			screenType: 1,
			segmentedMode: 3,
			segmentedTags: ["换行"],
			segmentMaxLength: 1024,
			segmentOverlapLength: 10,
			preprocessingRule: [],
		}
		let promise1 = uploadKnowledgeBySave({
			folderId,
			callCode,
			sceneId,
			modeIds,
			knowledgeBySaveRequests: uploadFilesArr.map((i: any) => ({ ...i, knowledgeName: i?.fileName, format: fileFormat(i?.fileName), source: i?.filePath, ...domainObj })),
			"operationType": "本地上传"
		})

		let promise2 = create_index(d)
		Promise.all([promise1, promise2]).finally(() => {
			setUploadLoaing(false)
			setIsModalOpen(false)
			handlesInfo({ folderId: folderId }) // 获取知识库详情列表
			message.success('上传成功')
		})
	}

	//关闭编辑弹窗
	const handleCancel = () => {
		setIsModalOpen(false)
	}

	// 删除知识点
	const handleDelete = (id: number[], name: string) => {
		const { callCode, modeIds } = konwSelectInfo
		let promise1 = delete_points({
			kw_name: callCode,
			source: [name],
			module: modeIds[0],
		})

		let promise2 = delKnowledgeOrDisable({
			knowledgeId: id,
			delFlag: 0,
			folderId,
			callCode: callCode,
			// teamId: route.query.teamId,
		})
		Promise.all([promise1, promise2]).finally(() => {
			message.success('删除成功')
			handlesInfo({ folderId: folderId }) // 获取知识库详情列表
		})
	}

	return {
		knowList,
		handles,
		setfolderId,
		folderId,
		resultInfo,
		Loading,
		folderInfo,
		setfolderInfo,
		isShowAddKnowledge,
		setIsShowAddKnowledge,
		isModalOpen,
		handleOk,
		handleCancel,
		setIsModalOpen,
		setUploadFilesArr,
		uploadFilesArr,
		uploadLoaing,
		handleDelete,
		handleReplaceFolder,
		selectKnowId,
		setselectKnowId,
		handlerecoverFolder
	};
}
